module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Navigation/Right 3-e192e9e33f973da36b532bb4d1144e29.svg";